import React, { ReactElement } from 'react';
import './index.less';

export const DetailsTitleShape = (hasActionButton = true): ReactElement => (
    <div className="DetailsTitleShape">
        <div className="rect" />
        {hasActionButton && <div className="buttonRect" />}
    </div>
);
